var map = {
	"./Auth/Login.svelte": [
		9570,
		570
	],
	"./Dash.svelte": [
		2286,
		286
	],
	"./Error.svelte": [
		9579,
		579
	],
	"./Projects/Add.svelte": [
		3671,
		671
	],
	"./Projects/Stats.svelte": [
		4165,
		165
	],
	"./Projects/Translate.svelte": [
		7465,
		465
	],
	"./Users/Create.svelte": [
		2632,
		632
	],
	"./Users/Edit.svelte": [
		4859,
		859
	],
	"./Users/Index.svelte": [
		7338,
		338
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 771;
module.exports = webpackAsyncContext;